<app-button icon="settings" (onClick)="onOpenDialog()" [disabled]="disabled">{{ 'reports.chart_settings' | translate }}</app-button>
